import { IFramework, IWebServiceManager, HttpMethod } from "@truckdown/framework";
import { ApiResultModel } from "../ApiResultModel";
import { IEncryptionService } from "./IEncryptionService";


class EncryptionService implements IEncryptionService {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    GetJsonWebToken<T>(payload: T): Promise<string> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/json-web-token',
            method: HttpMethod.PUT
        }, { "data": JSON.stringify(payload) });

        return new Promise<string>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<string>>(request)
                .then((res) => {
                    if (res.ok) {
                        resolve(res.data ?? '');
                    }
                    throw new Error('Error with get json web token request');
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                })
        });
    }

    async GetJsonWebTokenData<T>(token: string): Promise<T> {
        var res = await this.TryGetJsonWebTokenData<T>(token);
        if (res.ok) {
            return res.data as T;
        }
        throw new Error('Invalid token');
    }

    async TryGetJsonWebTokenData<T>(token: string): Promise<ApiResultModel<T>> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/json-web-token-data',
            method: HttpMethod.PUT
        }, { "data": token });

        return new Promise<ApiResultModel<T>>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<T>>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve({ ok: false, message: 'error' });
                })
        });
    }

    Hash(data: string): Promise<string> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/validate',
            method: HttpMethod.PUT
        }, { "data": data });

        return new Promise<string>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<string>>(request)
                .then((res) => {
                    if (res.ok) {
                        resolve(res.data ?? '');
                    }
                    throw new Error('Error with hash request');
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                })
        });
    }

    Encrypt(data: string): Promise<{ result: string, salt: string }> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/encrypt',
            method: HttpMethod.PUT
        }, { "data": data });

        return new Promise<{ result: string, salt: string }>((resolve, reject) => {
            this.manager
                .get<{ ok: boolean, message: string, data1: string, data2: string }>(request)
                .then((res) => {
                    if (res.ok) {
                        resolve({
                            result: res.data1 ?? '',
                            salt: res.data2 ?? ''
                        });
                    }
                    throw new Error('Error with encryption request');
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                })
        });
    }

    EncryptWithSalt(data: string, salt: string): Promise<string> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/encrypt-with-salt',
            method: HttpMethod.PUT
        }, { "key": data, "value": salt });

        return new Promise<string>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<string>>(request)
                .then((res) => {
                    if (res.ok) {
                        resolve(res.data ?? '');
                    }

                    throw new Error('Error with encryption request');
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                })
        });
    }

    Decrypt(data: string, salt: string): Promise<string> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/decrypt',
            method: HttpMethod.PUT
        }, { "key": data, "value": salt });

        return new Promise<string>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<string>>(request)
                .then((res) => {
                    if (res.ok) {
                        resolve(res.data ?? '');
                    }

                    throw new Error('Error with decryption request.');
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<IEncryptionService>('IEncryptionService', (frm) => {
        return new EncryptionService(frm);
    });
}
